import { render, staticRenderFns } from "./exchange_records.vue?vue&type=template&id=4f51e023&scoped=true"
import script from "./exchange_records.vue?vue&type=script&lang=js"
export * from "./exchange_records.vue?vue&type=script&lang=js"
import style0 from "./exchange_records.vue?vue&type=style&index=0&id=4f51e023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f51e023",
  null
  
)

export default component.exports